BuyButton = window.BuyButton ?= {}

Affirm = require '../../../affirm_info/frontend/affirm'

BuyButton.View = Backbone.View.extend
  el: "#purchase-cluster, .multi-option-overlay, .purchase_cluster_wrapper, #header-purchase-cluster"
  events:
    "click a.buy-button:not(.external-buy)": "buyButtonClicked"
    "click .view-options a" : "viewAllOptions"
    "click .multi-option-breakout input": "updateMultiOptionBreakoutButton"
    "click .multi-option-overlay-items input": "updateMultiOptionBreakoutButton"

  initialize: ({multiOptionEnabled, multiOptionInline}) ->
    @$buyContainer = @$(".buy")
    @$buyButton = @$("a.buy-button")
    @$giftButton = @$("a.buy-for-friend")
    @$dealHeroPrice = @$(".deal-hero-price, .multi-option-overlay-cluster-price")
    @$mainBtnPrice = @$("#main-button-formatted-price")
    @$priceBox = @$(".price, .multi-option-overlay-cluster-price")
    @$priceLabel = @$(".price-label, .multi-option-overlay-cluster-price-label")
    @$value = @$("#discount-value, .discount-value")
    @$smallPrice = @$('.price-small, .discount-value')
    @$multiOptionBreakout = @$('.multi-option-breakout, .modal-body')
    @$multiOptionOverlay = @$el.filter('.multi-option-overlay')
    @$multiOptions = @$('.multi-option-breakout input, .multi-option-overlay-item input')
    @$buyButtonLoader = @$buyButton.siblings('.order-processing-loader')
    @$finePrintDesc = $(".fine-print-description")
    @$headerTitles = $(".header-title-item")
    @$headerUrgencyPrice = $(".header-urgency-pricing")
    @$headerOptions = $(".header-options")

    if @$multiOptionOverlay.length
      @$discountPercent = @$('#discount-percent, .discount-percent')
      @$discountYouSave = @$('#discount-you-save, .discount-you-save')
      @$qtyBought = @$('.qty-bought')
      @$dealStatus = @$('.deal-status')
      @fixPossiblePriceOverflow()

    @hasBeenClicked = false
    @variationsSelected = false
    @multiOptionEnabled = multiOptionEnabled
    @multiOptionInline = multiOptionInline

    if @multiOptionInline
      @restoreOptionSelection()

    processLink = =>
      @processLink()

    BuyButton.eventBus.board('buy_button_clicked', processLink)(1000)

    window.DealEventPipe.on "priceUpdate", (priceData) =>
      @variationsSelected = priceData.variationsSelected
      @$buyButton.removeClass("login-disabled")
      @updatePrice priceData
      @updateValue priceData
      @updateBuyButton priceData
      @updateAffirmPrice priceData

  buyButtonClicked: (e) ->
    e.preventDefault()
    BuyButton.eventBus.go 'buy_button_clicked', e

  shouldShowPriceInTwoRows: ->
    includeMargin = true
    @$priceBox.outerWidth(includeMargin) + @$smallPrice.outerWidth(includeMargin) > @$dealHeroPrice.outerWidth(includeMargin)

  setPriceWithSale: (newPrice, regularPrice) ->
    @$priceBox.text newPrice
    @$priceBox.after "<span class='price-small'>#{regularPrice}</span>"
    @$smallPrice = @$dealHeroPrice.find('.price-small')
    @fixPossiblePriceOverflow()

  setOfferLabel: (offerLabel) ->
    return unless offerLabel

    offerLabel = "<span class='urgency-pricing-label'>#{offerLabel}</span>"

    if @$headerUrgencyPrice.length
      @$headerUrgencyPrice.append offerLabel

    @$dealHeroPrice.append offerLabel
    @$dealHeroPrice.addClass 'urgency-pricing'

  cleanPriceBox: ->
    @$priceBox.removeClass 'two-rows'
    @$dealHeroPrice.find('.price-small').remove()
    @$dealHeroPrice.removeClass 'urgency-pricing'
    @$dealHeroPrice.find('.urgency-pricing-label').remove()
    @$headerUrgencyPrice.find('.urgency-pricing-label').remove()

  setPriceBox: (price, sale) ->
    @cleanPriceBox()
    if sale?.urgencyPricing?
      @setPriceWithSale sale.urgencyPricing.newPrice, sale.urgencyPricing.regularPrice
      @setOfferLabel sale.urgencyPricing.pricingMetadata?.offerLabel
    else if sale?.offer?
      @$mainBtnPrice.text sale.offer.formattedNewPrice
      @setPriceWithSale sale.offer.formattedOldPrice, sale.offer.formattedValue
    else
      @$priceBox.text price

  updatePrice: ({variationsSelected, price, sale, lengthClass}) ->
    @$buyContainer.removeClass @currentPriceClass if @currentPriceClass
    @$buyContainer.addClass lengthClass if lengthClass
    @setPriceBox price, sale
    @currentPriceClass = lengthClass
    if variationsSelected
      @$priceLabel.hide()
    else
      @$priceLabel.show()

  updateAffirmPrice:  ({affirmAmount}) ->
    Affirm.updateAffirmPrice(affirmAmount)

  updateValue: ({value, hideOriginalPriceAndDiscount}) ->
    @$value.html if hideOriginalPriceAndDiscount then "" else value

  updateBuyButton: ({variationsSelected, buyUrl, sale}) ->
    if variationsSelected
      @$buyButton.attr("href", buyUrl)
      @$giftButton.attr("href", buyUrl)

  disableBuyButton: ->
    @hasBeenClicked = true
    @$buyButton.removeClass("state-buy")
    @$buyButton.addClass("state-disabled")
    @$headerOptions.fadeOut()
    @$buyButtonLoader.show()

  enableBuyButton: ->
    @hasBeenClicked = false
    @$buyButton.removeClass("state-disabled")
    @$buyButton.addClass("state-buy")
    @$headerOptions.fadeIn()
    @$buyButtonLoader.hide()

  processLink: ->
    unless @hasBeenClicked
      window.location = @$buyButton.attr("href")

    @disableBuyButton()

  updateMultiOptionBreakoutButton: (e) ->
    $option = @$multiOptions.filter(e.currentTarget)
    return if !$option.length or $option.hasClass('selected')

    @$multiOptions.removeClass 'selected'
    $option.addClass 'selected'

    value = $option.val()

    @$buyButton.attr 'href', value
    @$giftButton.attr 'href', value

    if @$multiOptionOverlay.length
      @updateClusterOptionPrice($option)
      @syncDealOptions($option)
      @cleanPriceBox()
      offerLabel = $option.attr('data-offer-label')
      @setOfferLabel offerLabel
      @$dealHeroPrice.addClass('urgency-pricing') if offerLabel
      @fixPossiblePriceOverflow()
    else
      @updateHeaderPrice($option)

    @updateHeaderTitle($option)

    BuyButton.eventBus.go('buy_button_clicked', e) if $option.parent('a').length

  updateHeaderPrice: ($option) ->
    formattedPrice = $option.attr('data-formatted-price') or ''
    formattedValue = if formattedPrice is $option.attr('data-formatted-value') then '' else $option.attr('data-formatted-value')
    @$priceBox.text(formattedPrice)
    @$smallPrice.text(formattedValue)

  updateHeaderTitle: ($option) ->
    breakoutOptionID = @getPurchaseClusterOptionId($option.attr('id'))
    @$headerTitles.removeClass 'checked'
    targetTitleId = "#header-title-#{breakoutOptionID}"
    selectedTitle = @$headerTitles.filter(targetTitleId)
    selectedTitle.addClass 'checked'

  updateClusterOptionPrice: ($option) ->
    formattedPrice = $option.attr('data-formatted-price') or ''
    formattedValue = if formattedPrice is $option.attr('data-formatted-value') then '' else $option.attr('data-formatted-value')
    offerLabel = $option.attr('data-offer-label') or ''
    soldMessage = $option.attr('data-sold-message') or ''
    breakoutOptionID = @getPurchaseClusterOptionId($option.attr('id'))
    finePrintDesc = $option.attr('data-description') or ''

    @$priceBox.text(formattedPrice)
    @$smallPrice.text(formattedValue)
    @fixPossiblePriceOverflow()

    # optional elements may or may not exist
    @updateClusterOptionDiscount($option)
    $option.find('.urgency-pricing-label').text(offerLabel)
    @updateUrgencyPricingMetaData(offerLabel, breakoutOptionID)

    if soldMessage.length
      @$qtyBought.text(soldMessage)
      @$dealStatus.show()
    else
      @$dealStatus.hide()

    @updateFinePrint(finePrintDesc)

  updateClusterOptionDiscount: ($option) ->
    discountPercentage = $option.attr('data-discount-percentage') or ''
    savings = $option.attr('data-savings') or ''
    if discountPercentage
      @$discountPercent.text(discountPercentage)
      @$discountYouSave.text(savings)
      $('.deal-discount').show()
    else
      $('.deal-discount').hide()

  updateUrgencyPricingMetaData: (offerLabel, breakoutOptionID) ->
    if offerLabel
      @$dealHeroPrice.addClass('urgency-pricing')
      @$dealHeroPrice.addClass('tooltip-trigger')
      @$dealHeroPrice.attr('data-bhw', 'UrgencyPrice')
      @$dealHeroPrice.attr('data-tooltip-id', "urgency-pricing-tooltip-#{ breakoutOptionID }")
      @$dealHeroPrice.attr('data-position', "left")
    else
      @$dealHeroPrice.removeClass('urgency-pricing')
      @$dealHeroPrice.removeClass('tooltip-trigger')
      @$dealHeroPrice.removeAttr('data-bhw')
      @$dealHeroPrice.removeAttr('data-tooltip-id')
      @$dealHeroPrice.removeAttr('data-position')

  fixPossiblePriceOverflow: ->
    @$priceBox.removeClass('two-rows')
    @$smallPrice.removeClass('two-rows')
    if @shouldShowPriceInTwoRows()
      @$priceBox.addClass('two-rows')
      @$smallPrice.addClass('two-rows')

  viewAllOptions: (e) ->
    e.preventDefault()
    BuyButton.eventBus.go 'view_options_clicked', e

  restoreOptionSelection: () ->
    @$el.find('.multi-option-breakout li input:first').trigger 'click'

  syncDealOptions: ($option) ->
    optionId = $option.attr('id')

    if optionId.indexOf('overlay') != -1
      breakoutOptionId = "##{@getPurchaseClusterOptionId(optionId)}"
      @reorderDealOptions(breakoutOptionId)
    else
      breakoutOptionId = "#overlay-#{optionId}"

    $(breakoutOptionId).prop('checked', true)

  getPurchaseClusterOptionId: (optionId) ->
    return '' unless optionId?

    return optionId.replace('overlay-', '')

  reorderDealOptions: (breakoutOptionId) ->
    $optionElem = $(breakoutOptionId).parents('li')

    return if $optionElem.is(':visible')

    $optionElem.insertBefore($optionElem.siblings('li').first())
    $optionElem.parent().find('li:visible:last').hide()
    $optionElem.show()

  updateFinePrint: (finePrintDesc) ->
    return unless finePrintDesc?.length
    $body = $(document.body)

    if $body.hasClass('getaways') or $body.hasClass('getaways-booking')
      finePrintLines = if I18n?.country is "US"
        tempLines = _.filter finePrintDesc.split(". "), (line) ->
          line.replace(/<[^>]*>/g, '').trim().length > 0

        tempLines = _.map tempLines, (line) -> "<li class='fine-print-description'>#{line}</li>"
        tempLines.join ''

      else
        "<span class='fine-print-description'>#{finePrintDesc.replace(/\n/g, '<br/>')}</span>"

      $(finePrintLines).insertBefore(@$finePrintDesc.first())
      @$finePrintDesc.remove()
      @$finePrintDesc = $('.fine-print-description')

    else
      @$finePrintDesc.html finePrintDesc


module.exports = BuyButton.View
